import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/list.css'
import router from './router/index.js'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' })

Vue.prototype.$hasPermission = function (tag) {
  const raw = sessionStorage.getItem('myValue')
  if (!raw) return true
  try {
    Vue.prototype.$authority = JSON.parse(raw)
  } catch (e) {
    return true
  }
  const walk = (nodes) => {
    if (!nodes) return false
    for (let i = 0; i < nodes.length; i++) {
      if (tag === nodes[i].tag) return !!nodes[i].visible
      if (walk(nodes[i].list)) return true
    }
    return false
  }
  return walk(Vue.prototype.$authority)
}

Vue.prototype.$setAuthority = function (authority) {
  Vue.prototype.$authority = authority
  sessionStorage.setItem('myValue', JSON.stringify(authority || []))
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
